import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BackendService,
  FileService,
  HttpOptions,
  PaginatedResponseModel,
} from '@ipg/ngx-frontend-toolset';
import { MediaResponse } from '../models/media.model';

export interface PictogramItem {
  _id: string;
  label: string;
  fileId: string;
  category?: string | null;
  metadata?: {
    size?: number;
    mimeType?: string;
    width?: number;
    height?: number;
  } | null;
}

export interface PictogramCopyRequest {
  pictogramIds: string[];
  clientId?: string | null;
  unitId?: string | null;
  groupId?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class PictogramService {
  private readonly _backend = inject(BackendService);
  private readonly _file = inject(FileService);

  getAll(
    options?: HttpOptions
  ): Observable<PaginatedResponseModel<PictogramItem[]>> {
    return this._backend.get<PaginatedResponseModel<PictogramItem[]>>(
      '/pictograms',
      options
    );
  }

  copy(
    data: PictogramCopyRequest,
    options?: HttpOptions
  ): Observable<MediaResponse[]> {
    return this._backend.post<MediaResponse[]>('/pictograms/copy', data, options);
  }

  getFileUrl(fileId: string): string {
    return this._file.get(fileId, true).href;
  }
}
